







































import { Component, Vue } from 'vue-property-decorator';
import UserNotification from '@/classes/UserNotification';
import moment from 'moment';

@Component
export default class NotificationList extends Vue {
    public currPage: number = 1;
    public perPage: number = 10;

    get currentPage(): number {
      if (this.currPage > this.pages) {
        return this.pages;
      } else {
        return this.currPage;
      }
    }

    set currentPage(num: number) {
      this.currPage = num;
    }

    get pages(): number {
      return Math.ceil(this.totalRows / this.perPage);
    }

    get items(): UserNotification[] {
        return this.$store.getters['notifications/getUserNotifications'];
    }

    get totalRows(): number {
        if (this.items) {
            return this.items.length === 0 ? 1 : this.items.length;
        } else {
            return 1;
        }
    }

    get fields() {
        return [{
            key: 'subject',
            label: 'Subject',
            sortable: true
        }, {
            key: 'publishDateTimeAsNumber',
            label: 'Publish Date/Time',
            sortable: true
        }, {
            key: 'expirationDateTimeAsNumber',
            label: 'Expiration Date/Time',
            sortable: true
        }, {
            key: 'submittedDateAsNumber',
            label: 'Date/Time Created',
            sortable: true
        }, {
            key: 'submittedUserId',
            label: 'Created by',
            sortable: true
        }, {
            key: 'editDelete',
            label: ''
        }];
  }

  public getUserProfileName(id: number) {
    const user = this.$store.getters.getUserProfileById(id);
    if (user) {
      return user.getFullName();
    } else {
      return '';
    }
  }

  public getDateTimeStringUTC(val: Date | null | undefined): string {
    if (val === undefined || val === null || !moment(val).isValid) {
      return '';
    } else {
      return moment.utc(val).format('MM/DD/YYYY LT');
    }
  }

  public getDateTimeString(val: Date | null | undefined): string {
    if (val === undefined || val === null || !moment(val).isValid) {
      return '';
    } else {
      return moment(val).format('MM/DD/YYYY LT');
    }
  }
}
